// defaultSettings.ts 또는 enum.ts에 추가할 내용
import {
    UserGoalDisplaySetting,
    UserTodoDisplaySetting,
} from '../types/databaseTypes';
import { CompletedFilter } from './filter';

// 할일 표시 설정 기본값
export const DEFAULT_TODO_DISPLAY_SETTINGS: Pick<
    UserTodoDisplaySetting,
    'show_goals' | 'show_empty_goals'
> = {
    show_goals: true,
    show_empty_goals: true,
};

// 목표 표시 설정 기본값 - 개발하면서 수정 예정
export const DEFAULT_GOAL_DISPLAY_SETTINGS: Pick<
    UserGoalDisplaySetting,
    | 'completed_filter'
    | 'display_properties'
    | 'grouping'
    | 'ordering'
    | 'ordering_dir'
    | 'view_type'
> = {
    completed_filter: CompletedFilter.TODAY,
    display_properties: ['title', 'due_date'], // 표시할 속성 목록
    grouping: null,
    ordering: 'due_date',
    ordering_dir: 'asc',
    view_type: 'list',
};
